import { useTranslation } from 'react-i18next';
import BoldBlue from './BoldBlue';
import Popup from './Popup';
import { useState } from 'react';
import Input from './Input';

const AwardsAdd = (props) => {

    const { i18n } = useTranslation('common');
    const [popupOpen, setPopupOpen] = useState(false); 
    const [title, setTitle] = useState('');
    const [year, setYear] = useState('');

    let decodedAwards = [];
    try {
        decodedAwards = JSON.parse(props.awards);
    } catch (error) {
        console.log(error);
        decodedAwards = [];
    }

    function addLink(event) {
        event.preventDefault();
        let newLink = {
            title,
            year
        }
        decodedAwards.push(newLink);
        props.setAwards(JSON.stringify(decodedAwards));
        setPopupOpen(false);
        setTitle('');
        setYear('');
    }

    return (
        <>
            <BoldBlue style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)}>{i18n.language === "fr" ? "Ajouter un award" : "Add an award"} +</BoldBlue><br/>
            {popupOpen &&
                <Popup close={() => setPopupOpen(false)}>
                    <span className='thin'>{i18n.language === "fr" ? "Ajouter un award" : "Add an award"}</span><br/>
                    <Input style={{width:"100%"}} onChange={(event) => setTitle(event.target.value)} placeholder={i18n.language === "fr" ? "Award" : "Award"} /><br/>
                    <Input style={{width:"100%"}} type="number" onChange={(event) => setYear(event.target.value)} placeholder={i18n.language === "fr" ? "Année" : "Year"} /><br/>
                    {title && year && <button onClick={addLink}>{i18n.language === 'fr' ? 'Ajouter' : 'Add'}</button>}
                </Popup>
            }
        </>
    );
};

export default AwardsAdd;
